import React from 'react';

const PrivacyNotice = () => {
  return (
    <div className="border border-black rounded-md shadow-xl p-6 text-justify bg-yellow-100">
      <h1 className="text-2xl font-bold text-red-600">Privacy Notice</h1>
      <p className="text-lg mt-4 text-gray-800">
        We take your privacy seriously. All audio files uploaded to FASA Web are processed securely
        and are not stored on our servers. We ensure that your data remains private and is used only
        for the purpose of providing you with the transcription service.
      </p>
    </div>
  );
}

export default PrivacyNotice;
